import axios from 'axios';

import { parseMultiCompanySuccessEnvelope } from 'src/contracts/multiCompany/v1';

export interface AdminSelfProfile {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  profileImage: string;
}

const profileFrom = (value: unknown): AdminSelfProfile => {
  const envelope = parseMultiCompanySuccessEnvelope<AdminSelfProfile>(value);
  if (!envelope?.data) throw new Error('Admin profile response is invalid.');
  return envelope.data;
};

export async function getAdminSelfProfile(): Promise<AdminSelfProfile> {
  return profileFrom((await axios.get('/auth/admin/profile')).data);
}

export async function updateAdminSelfProfile(input: {
  firstName: string;
  lastName: string;
}): Promise<AdminSelfProfile> {
  return profileFrom((await axios.put('/auth/admin/profile', input)).data);
}

export async function uploadAdminSelfAvatar(
  file: File
): Promise<AdminSelfProfile> {
  const body = new FormData();
  body.append('file', file);
  return profileFrom(
    (await axios.post('/auth/admin/profile/avatar', body)).data
  );
}

export async function changeAdminSelfPassword(input: {
  oldPassword: string;
  newPassword: string;
}): Promise<void> {
  await axios.post('/auth/admin/profile/change-password', input);
}
